module.exports = __webpack_public_path__ + "static/media/speaker_test_sound.549c1f03.wav";